import { motion } from "framer-motion";

const GuaranteeSeal = () => (
  <motion.div
    data-testid="guarantee-seal"
    className="absolute -top-12 right-4 z-20 w-28 sm:-right-8 sm:-top-14 sm:w-36"
    initial={{ opacity: 0, scale: 0.5, rotate: -20 }}
    whileInView={{ opacity: 1, scale: 1, rotate: 8 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay: 0.4, type: "spring", bounce: 0.45 }}
  >
    <motion.img
      src="/selo-garantia.png"
      alt="Compra garantida — 7 dias — 100% seguro"
      className="w-full drop-shadow-[0_10px_25px_rgba(0,0,0,0.6)]"
      animate={{ y: [0, -6, 0] }}
      transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
    />
  </motion.div>
);

export default GuaranteeSeal;
